import { StatusType } from '../types';

export const getMode = (status: StatusType) => {
  if (status === 'productListCountAlert' || status === 'listCountAlert') {
    return 'alert';
  }
  return status;
};
